import React, { useContext } from 'react';
import Link from '@/helpers/Link';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AccountContext } from '@/context/account.context';
import { teamHelpers } from '@/utils/helpers';
import useAgencyConfiguration from '@/hooks/useAgencyConfiguration';
import useAssessments from '@/hooks/useAssessments';
import LoginButtons from '../LoginButtons/LoginButtons';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const LoggedInMenuList = function ({ t, classes, mobile, onCloseMenu }) {
  const { isPro, isLoggedIn, affiliation, data: accountInfo } = useContext(AccountContext);
  const { agencyConfiguration } = useAgencyConfiguration();
  const { assessments, isLoadingAssessments } = useAssessments();

  const showAssessmentsLink = !!assessments?.length;

  const showTeamsLink = () => {
    // TODO is this logic working? I'm not seeing how userHasTeams would be true if !loggedIn
    return (
      (!isLoggedIn && teamHelpers.userHasTeams(accountInfo, agencyConfiguration)) || (agencyConfiguration?.enable_teams && affiliation?.is_admin)
    );
  };

  const proMenuListItems = (withDashboard) => {
    const items = [
      { text: t('Clients'), icon: 'user', link: '/clients' },
      { text: t('My Collections'), icon: 'book', link: '/collections?page=my' },
      { text: t('My Bookmarks'), icon: 'bookmark', link: '/bookmarks' },
      {
        text: t('Assessments'),
        hidden: !isLoadingAssessments && !showAssessmentsLink, // loading has finished and there's nothing to show
        loading: isLoadingAssessments,
        icon: 'paste',
        link: '/plan#assessments'
      }
    ];
    if (affiliation?.organization_name) {
      items.unshift({
        text: affiliation.organization_name,
        icon: 'sitemap',
        link: '/org/' + affiliation.fetchable_id
      });
    }
    if (showTeamsLink()) {
      items.push({ text: t('Groups'), icon: 'handshake', link: '/groups' });
    }
    if (withDashboard) {
      items.unshift({
        text: t('Dashboard'),
        icon: 'house',
        link: '/dashboard'
      });
    }
    return items;
  };

  const memberMenuListItems = [
    { text: t('My Plan'), icon: 'house', as: 'Link', link: '/plan#resources' },
    {
      text: t('My Assessments'),
      hidden: !isLoadingAssessments && assessments.length == 0,
      loading: isLoadingAssessments,
      icon: 'paste',
      link: '/plan#assessments'
    },
    {
      text: t('Saved Collections'),
      icon: 'book',
      link: '/collections?page=my'
    },
    { text: t('My Documents'), icon: 'folder-open', link: '/plan#documents' }
  ];

  const getMobileMenuItems = (item) => {
    return (
      <React.Fragment key={item.link}>
        {!item.hidden && (
          <li className={classes.mobileMenuItem} onClick={item.loading ? undefined : onCloseMenu}>
            {item.loading ? <Skeleton width={100} height={14} /> : renderLink(item)}
          </li>
        )}
      </React.Fragment>
    );
  };

  const getProMenuItems = (item) => {
    return (
      <React.Fragment key={item.link}>
        {!item.hidden &&
          (item.loading ? (
            <Dropdown.Item disabled>
              <Skeleton width="100%" height={14} />
            </Dropdown.Item>
          ) : (
            <Dropdown.Item href={item.link}>
              <FontAwesomeIcon icon={['fa', item.icon]} aria-hidden="true" /> &nbsp;
              {item.text}
            </Dropdown.Item>
          ))}
      </React.Fragment>
    );
  };

  const renderLink = (item) => {
    if (item.link.includes('plan')) {
      return (
        <Link className={classes.mobileMenuLink} href={item.link}>
          {renderLinkHTML(item)}
        </Link>
      );
    } else {
      return (
        <a className={classes.mobileMenuLink} href={item.link}>
          {renderLinkHTML(item)}
        </a>
      );
    }
  };

  const renderLinkHTML = (item) => {
    return (
      <span>
        <FontAwesomeIcon icon={['fa', item.icon]} aria-hidden="true" /> &nbsp;
        {item.text}
      </span>
    );
  };

  if (mobile) {
    if (isPro) {
      return <ul className={classes.mobileMenuItems}>{proMenuListItems().map((item) => getMobileMenuItems(item))}</ul>;
    } else if (isLoggedIn) {
      return <ul className={classes.mobileMenuItems}>{memberMenuListItems.map((item) => getMobileMenuItems(item))}</ul>;
    } else {
      return <LoginButtons t={t} classes={classes} mobile={true} onCloseMenu={onCloseMenu} />;
    }
  } else {
    if (isPro) {
      return <>{proMenuListItems(true).map((item) => getProMenuItems(item))}</>;
    } else if (isLoggedIn) {
      return <>{memberMenuListItems.map((item) => getProMenuItems(item))}</>;
    }
  }
};

export default LoggedInMenuList;
